import { fromPairs, pipe } from 'ramda';
import { map, Maybe, orElse } from 'core/maybe';
import { queryClient } from 'queries';
import { APPROVERS_CONFIGURATION_KEY } from 'queries/timesheets/constants';
import { client } from '../client';

type ApproverId = number;
type UserId = number;

export type ApproverMap = Record<UserId, ApproverId>;

type ApproverMapEntry = {
  userId: UserId;
  approverId: ApproverId;
};

const get = (): Promise<ApproverMap> =>
  client
    .get<ApproverMapEntry[]>('/timesheets/approvers')
    .then((entries) =>
      fromPairs(
        entries.map(
          ({ userId, approverId }) =>
            [userId, approverId] as [UserId, ApproverId],
        ),
      ),
    );

export type ApproverUpdate = {
  userId: UserId;
  approverId: Maybe<ApproverId>;
};

const update = ({ userId, approverId }: ApproverUpdate): Promise<void> =>
  pipe(
    () => approverId,
    map((x) => x.toString()),
    orElse(''),
    (x) => `timesheets/approvers?userId=${userId}&approverId=${x}`,
    (x) =>
      client.put(x).then(() => {
        queryClient.refetchQueries(APPROVERS_CONFIGURATION_KEY);
      }),
  )();

export const ApproversApi = {
  get,
  update,
};
